import Close from '@hyphengroup/cms-components/components/icons/Close';

export default Close;
